export default __webpack_public_path__ + "static/media/1458.8cc365e5.png";